import { _get, _post } from "./Axios";

export default class KoreksiApi {
  static getListKoreksiHasilPenilaian(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/list?" + params);
  }

  static getListPengajuanKoreksi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/list-pengajuan?" + params);
  }

  static createKoreksi(data) {
    return _post("koreksi/create", data);
  }

  static getDetailPenilaianKinerja(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/kinerja/list?" + params);
  }

  static getDetailHasilKoreksiPenilaianKinerja(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/kinerja/compare-kinerja?" + params);
  }

  static addKoreksiPenilaianKinerja(data) {
    return _post("koreksi/kinerja/create", data);
  }

  static addNoteKoreksiPenilaianKinerja(data) {
    return _post("koreksi/kinerja/catatan", data);
  }

  // ---------------------------------------------------------

  static getDetailPenugasanKhusus(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/penugasan?" + params);
  }

  static getDetailHasilKoreksiPenugasanKhusus(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/penugasan/compare-penugasan?" + params);
  }

  static addKoreksiPenugasanKhusus(data) {
    return _post("koreksi/penugasan/create", data);
  }

  static addNoteKoreksiPenugasanKhusus(data) {
    return _post("koreksi/penugasan/catatan", data);
  }

  // ---------------------------------------------------------

  static getDetailPengurangan(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/pengurangan/?" + params);
  }

  static getDetailHasilKoreksiPengurangan(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/pengurangan/compare-pengurangan?" + params);
  }

  static addKoreksiPengurangan(data) {
    return _post("koreksi/pengurangan/create", data);
  }

  static addNoteKoreksiPengurangan(data) {
    return _post("koreksi/pengurangan/catatan", data);
  }

  // ---------------------------------------------------------

  static getDetailKompetensi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/kompetensi/list?" + params);
  }

  static getDetailHasilKoreksiKompetensi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("koreksi/kompetensi/compare-kompetensi?" + params);
  }

  static addKoreksiKompetensi(data) {
    return _post("koreksi/kompetensi/create", data);
  }

  static addNoteKoreksiKompetensi(data) {
    return _post("koreksi/kompetensi/catatan", data);
  }

  // ---------------------------------------------------------

  static getDetailPenilaianAkhir(data) {
    return _post("koreksi/penilaian-akhir", data);
  }

  static addNoteKoreksiPenilaianAkhir(data) {
    return _post("koreksi/penilaian-akhir/catatan", data);
  }
  
  // --------------------------------------------------------

  static submitKeputusan(data) {
    return _post("koreksi/keputusan", data);
  }
}
